"use strict";
/* tslint:disable */

/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeKarrotBridge = void 0;

function makeKarrotBridge(_ref) {
  var driver = _ref.driver;
  return {
    driver: driver,

    /**
     * 긍정적인 햅틱 (ex: 회원가입 성공)
     */
    setHapticSuccess: function setHapticSuccess(req) {
      return driver.onQueried("REQ.HAPTIC.SUCCESS", req);
    },

    /**
     * 부정적인 햅틱 (ex: 문자 인증 실패)
     */
    setHapticError: function setHapticError(req) {
      return driver.onQueried("REQ.HAPTIC.ERROR", req);
    },

    /**
     * 선택 했을때 햅틱 (Long Press) (ex: 텍스트에 있는 특정 문장을 드래그하기 위한 롱프레스)
     */
    setHapticSelect: function setHapticSelect(req) {
      return driver.onQueried("REQ.HAPTIC.SELECT", req);
    },

    /**
     * 터치 했을 때 햅틱 (Press)
     */
    setHapticLightFeedback: function setHapticLightFeedback(req) {
      return driver.onQueried("REQ.HAPTIC.LIGHT_FEEDBACK", req);
    },

    /**
     * 분석 시스템에 이벤트를 로깅해요 (Firebase / Karrot)
     */
    logEvent: function logEvent(req) {
      return driver.onQueried("REQ.ANALYTICS.LOG_EVENT", req);
    },

    /**
     * 유저의 현재 위치를 요청해요
     */
    getCurrentPosition: function getCurrentPosition(req) {
      return driver.onQueried("REQ.GEOLOCATION.CURRENT_POSITION", req);
    },

    /**
     * 현재 웹뷰의 이미지 피커를 설정해요
     */
    configureImage: function configureImage(req) {
      return driver.onQueried("REQ.IMAGE.CONFIGURE", req);
    },

    /**
     * 이미지 피커를 열어요 (iOS Only)
     */
    pickImages: function pickImages(req) {
      return driver.onQueried("REQ.IMAGE.PICK", req);
    },

    /**
     * 앱 정보를 요청해요
     */
    getAppInfo: function getAppInfo(req) {
      return driver.onQueried("REQ.INFO.APP", req);
    },

    /**
     * 현재 앱에 체크인 된 지역 정보를 요청해요
     */
    getRegionInfo: function getRegionInfo(req) {
      return driver.onQueried("REQ.INFO.REGION", req);
    },

    /**
     * 로그인 한 유저 정보를 요청해요
     */
    getUserInfo: function getUserInfo(req) {
      return driver.onQueried("REQ.INFO.USER", req);
    },

    /**
     * 플러그인(하프뷰)을 열어요
     */
    openPlugin: function openPlugin(req) {
      return driver.onQueried("REQ.PLUGIN.OPEN", req);
    },

    /**
     * 플러그인(하프뷰)을 닫아요
     */
    closePlugin: function closePlugin(req) {
      return driver.onQueried("REQ.PLUGIN.CLOSE", req);
    },

    /**
     * 현재 열려있는 플러그인(하프뷰)의 스타일을 변경해요
     */
    styleCurrentPlugin: function styleCurrentPlugin(req) {
      return driver.onQueried("REQ.PLUGIN.STYLE", req);
    },

    /**
     * 지역 설정을 변경해요
     */
    changeRegion: function changeRegion(req) {
      return driver.onQueried("REQ.REGION.CHANGE", req);
    },

    /**
     * 네이티브 공유 모달을 열어요
     */
    share: function share(req) {
      return driver.onQueried("REQ.SHARE.OPEN", req);
    },

    /**
     * 토스트를 열어요
     */
    openToast: function openToast(req) {
      return driver.onQueried("REQ.TOAST.OPEN", req);
    },

    /**
     * 새 웹뷰를 열어요
     */
    pushRouter: function pushRouter(req) {
      return driver.onQueried("REQ.ROUTER.PUSH", req);
    },

    /**
     * 새 웹뷰를 Present로 열어요. (iOS에서만 특별하게 작동해요. Android에서는 REQ.ROUTER.PUSH와 동일하게 작동해요.)
     */
    pushRouterWithPresent: function pushRouterWithPresent(req) {
      return driver.onQueried("REQ.ROUTER.OPEN", req);
    },

    /**
     * 현재 웹뷰를 교체해요
     */
    replaceRouter: function replaceRouter(req) {
      return driver.onQueried("REQ.ROUTER.REPLACE", req);
    },

    /**
     * 백그라운드에서 해당 웹뷰를 미리 다운로드 받아놓아요
     */
    prefetchRouter: function prefetchRouter(req) {
      return driver.onQueried("REQ.ROUTER.PREFETCH", req);
    },

    /**
     * 웹뷰를 닫아요
     */
    closeRouter: function closeRouter(req) {
      return driver.onQueried("REQ.ROUTER.CLOSE", req);
    },

    /**
     * 현재 띄워져있는 모든 웹뷰를 닫아요
     */
    dangerouslyCloseAllRouters: function dangerouslyCloseAllRouters(req) {
      return driver.onQueried("REQ.ROUTER.CLOSE_ALL", req);
    },

    /**
     * 현재 웹뷰의 스타일을 변경해요
     */
    styleCurrentRouter: function styleCurrentRouter(req) {
      return driver.onQueried("REQ.ROUTER.STYLE", req);
    },

    /**
     * 앱 저장소에 데이터를 저장해요
     */
    setItemInStorage: function setItemInStorage(req) {
      return driver.onQueried("REQ.STORAGE.SET", req);
    },

    /**
     * 앱 저장소에 저장된 데이터를 불러와요
     */
    getItemInStorage: function getItemInStorage(req) {
      return driver.onQueried("REQ.STORAGE.GET", req);
    },

    /**
     * 앱 저장소에 저장된 모든 데이터를 불러와요
     */
    getAllItemsInStorage: function getAllItemsInStorage(req) {
      return driver.onQueried("REQ.STORAGE.GET_ALL", req);
    },

    /**
     * 앱 저장소에 저장된 데이터를 삭제해요
     */
    deleteItemInStorage: function deleteItemInStorage(req) {
      return driver.onQueried("REQ.STORAGE.DELETE", req);
    },

    /**
     * Stream에 이벤트를 발행합니다
     */
    emitToStream: function emitToStream(req) {
      return driver.onQueried("REQ.STREAM.EMIT", req);
    },

    /**
     * 클립보드에 텍스트를 복사해요 (안드로이드에서는 클립보드 접근권한이 없어서 브릿지가 필요해요. IOS는 js의 클립보드가 정상 동작해요)
     */
    copyClipboard: function copyClipboard(req) {
      return driver.onQueried("REQ.CLIPBOARD.COPY", req);
    },

    /**
     * Stream을 구독합니다
     */
    subscribeStream: function subscribeStream(req, listener) {
      return driver.onSubscribed("REQ.STREAM.SUBSCRIBE", req, listener);
    }
  };
}

exports.makeKarrotBridge = makeKarrotBridge;